import React from 'react'

/**
 * Properties required by the save component
 */
export interface ISaveProps {
    autoSave: boolean
    onAutosaveToggle: () => void
    onSave: () => void
}

/**
 * Component creates events related to saving application state
 * @param {ISaveProps} props properties required by the component
 */
function SaveComponent(props: ISaveProps) {
    return (
        <form>
            <div className="form-check form-check-inline">
                <div className="btn-group-toggle mr-2">
                    <label
                        className={`btn btn-outline-secondary ${
                            props.autoSave ? 'active' : ''
                        }`}>
                        <input
                            type="checkbox"
                            onChange={props.onAutosaveToggle}
                            checked={props.autoSave}
                        />
                        Autosave is {props.autoSave ? 'On' : 'Off'}
                    </label>
                </div>
                {!props.autoSave && (
                    <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={props.onSave}>
                        Save
                    </button>
                )}
            </div>
        </form>
    )
}

export default SaveComponent
